import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@peer-start/ui/reducate";
import { ArrowRight } from "lucide-react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import type { ShellBreadcrumb } from "../types/breadcrumbs.js";

export function ShellBreadcrumbs({ breadcrumbs }: { breadcrumbs: readonly ShellBreadcrumb[] }) {
  const { t } = useTranslation();
  return (
    <Breadcrumb aria-label={t("breadcrumbs.label")} className="hidden min-w-0 md:block">
      <BreadcrumbList className="flex-nowrap">
        {breadcrumbs.map((crumb, index) => {
          const current = index === breadcrumbs.length - 1;
          const label =
            crumb.label ?? (crumb.labelKey === "breadcrumbs.situationCard" ? "" : t(crumb.labelKey));
          return (
            <Fragment key={`${crumb.labelKey}-${index}`}>
              {index > 0 ? (
                <BreadcrumbSeparator>
                  <ArrowRight aria-hidden="true" />
                </BreadcrumbSeparator>
              ) : null}
              <BreadcrumbItem className="min-w-0">
                {crumb.to && !current ? (
                  <BreadcrumbLink asChild>
                    <NavLink
                      className="truncate rounded-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
                      data-control-id={`shell.breadcrumb.${crumb.labelKey}`}
                      end
                      to={crumb.to}
                    >
                      {label}
                    </NavLink>
                  </BreadcrumbLink>
                ) : current ? (
                  <BreadcrumbPage className="truncate" data-control-id="shell.breadcrumb.current">
                    {label}
                  </BreadcrumbPage>
                ) : (
                  <span className="truncate">{label}</span>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
